import { render, staticRenderFns } from "./TableActiveTimeByLapses.vue?vue&type=template&id=2b006520&scoped=true&"
import script from "./TableActiveTimeByLapses.vue?vue&type=script&lang=js&"
export * from "./TableActiveTimeByLapses.vue?vue&type=script&lang=js&"
import style0 from "./TableActiveTimeByLapses.vue?vue&type=style&index=0&id=2b006520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b006520",
  null
  
)

export default component.exports